import {TSRole} from '../../models/enums/TSRole';
/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';
import ILogService = angular.ILogService;

export default class IsNeuInStatusService {

    private _map: Map<TSRole, Map<TSSchadenfallStatus, boolean>> = new Map<TSRole, Map<TSSchadenfallStatus, boolean>>();

    static $inject = ['$log'];

    /* @ngInject */
    constructor(private $log: ILogService) {

        /*IsNeuInStatus für Superadmin*/
        let isNeuInStatusSuperadmin: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        isNeuInStatusSuperadmin.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.SUPER_ADMIN, isNeuInStatusSuperadmin);

        let isNeuInStatusfsAdmin: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusfsAdmin.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.FONDSSUISSE_ADMIN, isNeuInStatusfsAdmin);

        let isNeuInStatusfsSachbearbeiter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusfsSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.FONDSSUISSE_SACHBEARBEITER, isNeuInStatusfsSachbearbeiter);

        let isNeuInStatusAnlaufstelleSachbearbeiter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSachbearbeiter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.ANLAUFSTELLE_SACHBEARBEITER, isNeuInStatusAnlaufstelleSachbearbeiter);

        let isNeuInStatusAnlaufstelleVerwalter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleVerwalter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.ANLAUFSTELLE_VERWALTER, isNeuInStatusAnlaufstelleVerwalter);

        let isNeuInStatusAnlaufstelleSchaetzer: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusAnlaufstelleSchaetzer.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.ANLAUFSTELLE_SCHAETZER, isNeuInStatusAnlaufstelleSchaetzer);

        let isNeuInStatusKantonInspektor: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.AUSZAHLUNG, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusKantonInspektor.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.KANTON_INSPEKTOR, isNeuInStatusKantonInspektor);

        let isNeuInStatusKantonVerwalter: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.AUSZAHLUNG, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.ABGESCHLOSSEN, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, true);
        isNeuInStatusKantonVerwalter.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, true);
        this._map.set(TSRole.KANTON_VERWALTER, isNeuInStatusKantonVerwalter);

        let isNeuInStatusBetroffener: Map<TSSchadenfallStatus, boolean> = new Map<TSSchadenfallStatus, boolean>();
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.IMPORTIERT, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.NEU, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.NEU_PAPIER_FS, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.AUFTRAG_SCHAETZER, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.WIEDERHERSTELLUNG, true);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.AUSZAHLUNG, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.ABGESCHLOSSEN, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.ABGELEHNT_ANLAUFSTELLE, false);
        isNeuInStatusBetroffener.set(TSSchadenfallStatus.ABGELEHNT_FONDSSUISSE, false);
        this._map.set(TSRole.BETROFFENER, isNeuInStatusBetroffener);

    }

    public isIsNeuInStatusVisibleForStatusAndRole(role: TSRole | undefined, status: TSSchadenfallStatus): boolean {
        if (role) {
            return this.getIsNeuInStatus(role, status);
        } else {
            this.$log.warn('no role passed');
            return false;
        }
    }

    public getIsNeuInStatus(role: TSRole, status: TSSchadenfallStatus): boolean {
        if (role) {
            let isNeuInStatusForRole = this._map.get(role);
            if (isNeuInStatusForRole) {
                let o: boolean | undefined = isNeuInStatusForRole.get(status);
                if (o) {
                    return o;
                }
                return false;
            } else {
                this.$log.error('no isNeuInStatus definitions for role ' + role);
            }
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/isNeuInStatusService.ts